import { render, staticRenderFns } from "./SendSignForm.vue?vue&type=template&id=3825d42b&scoped=true&"
import script from "./SendSignForm.vue?vue&type=script&lang=ts&"
export * from "./SendSignForm.vue?vue&type=script&lang=ts&"
import style0 from "./SendSignForm.vue?vue&type=style&index=0&id=3825d42b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825d42b",
  null
  
)

export default component.exports